import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore from 'store/configureStore';
import history from 'utils/history';
import App from 'containers/App';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import TagManager from 'react-gtm-module';
// eslint-disable-next-line import/named
import { i18nInit } from './i18n';
import * as serviceWorker from './serviceWorker';

const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');
// eslint-disable-next-line max-len
// pk_test_51IAxXZIHRoT06REwM6rb7aIs5LLxRS9v91xYGIfsTx8LtQjFZIQj6d91EVKOfqkRg5kb3mWpSYIQTLSaJqGT3P2100k7UPfSqW
// eslint-disable-next-line max-len
// pk_live_51IAxXZIHRoT06REwjztBoXVSxGzDvjzgos7BPEg1j2iKaYOEFdeffHdDZjDizIFygNY5EUgPRQLNTJaI6ESw6FpK00DGxi7Itu
const stripeToken = window.location.host.includes('develop') || window.location.host.includes('localhost') ? 'pk_test_51IAxXZIHRoT06REwM6rb7aIs5LLxRS9v91xYGIfsTx8LtQjFZIQj6d91EVKOfqkRg5kb3mWpSYIQTLSaJqGT3P2100k7UPfSqW' : 'pk_live_51IAxXZIHRoT06REwjztBoXVSxGzDvjzgos7BPEg1j2iKaYOEFdeffHdDZjDizIFygNY5EUgPRQLNTJaI6ESw6FpK00DGxi7Itu';
const stripePromise = loadStripe(stripeToken);

const tagManagerArgs = {
  gtmId: 'GTM-MQ929XP',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18nInit}>
      <ConnectedRouter history={history}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </ConnectedRouter>
    </I18nextProvider>
  </Provider>, MOUNT_NODE,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
